import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { formatChurnRate } from "../../../../utils/formatChurnRate";

const MonthlyAttritionRate = ({ qa }) => {
  const { churnRate, tooltip, churnRateChange } = useSelector(
    (state) => state.membershipUnits.membershipUnits.monthlyAttritionRate
  );

  const actualValue = formatChurnRate(churnRate);

  return (
    <div className="content__el">
      <DataDisplay
        label="Monthly Attrition Rate"
        type="percentage"
        showDecimal
        toFixedValue={actualValue > 0 ? 2 : undefined}
        value={actualValue}
        disableAnimation={qa}
        toolTipContent={tooltip}
        toolTipId="membershipChurnRateToolTip"
        changeProps={{
          changeValue: churnRateChange,
          toolTip: "Percentage change from previous month",
          showBorder: true,
          positiveColor: "#c7343e",
          negativeColor: "#21e981"
        }}
      />
    </div>
  );
};

export default MonthlyAttritionRate;
